import {Fragment, useEffect, useState} from "react";
import {format} from "date-fns";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEdit} from "@fortawesome/free-solid-svg-icons";
import {BreadCrumb, SkeletonTableLoading, Table, CenteredModal, FormInput} from "~/components";
import AppParamAPI from "~/api/appParamApi";
import {useForm} from "react-hook-form";
import CommonAPI from "~/api/commonApi";
import {toast} from "react-toastify";

const breadCrumbItem = [
    { text: "Home", to: "/ai-chatbot/administrator", isActive: false },
    { text: "Application Parameter", to: "", isActive: true },
]

function ApplicationParameter(){
    const [reloadTable, setReloadTable] = useState(false);
    const [appParam, setAppParam] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const tableConfig = {
        columns: [
            {
                name: 'PARAM ID',
                width: '70px',
                className: 'fw-bold',
                key: 'ParamId'
            },
            {
                name: 'PARAM VALUE',
                width: '250px',
                key: 'ParamValue'
            },
            {
                name: 'DESCRIPTION',
                width: '150px',
                key: 'Description'
            },
            {
                name: 'MODIFIED BY',
                width: '150px',
                key: 'ModifiedBy'
            },
            {
                name: 'MODIFIED DATE',
                width: '150px',
                key: 'ModifiedDate',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.ModifiedDate), "dd-MM-yyyy")}</span>
                    )
                }
            },
            {
                name: 'ACTION',
                width: '70px',
                key: 'Action',
                headerClassName: 'text-center',
                className: 'text-center',
                template: (row) => {
                    return (
                        <span><FontAwesomeIcon onClick={()=> handleEditAppParam(row.ParamId)} icon={faEdit} className="text-primary cursor-pointer"/></span>
                    )
                }
            }
        ],
        tableKey: "TableApplicationParam"
    }

    useEffect(() => {
        setLoading(true);
        AppParamAPI.getAll()
            .then((res) => {
                setAppParam(res.data);
            })
            .catch((err) => {
                ;
            })
            .finally(() => {
                setLoading(false);
            })
    }, [reloadTable]);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();

    const handleEditAppParam = (id) => {
        AppParamAPI.getById(id)
            .then(res => {
                reset(res.data);
                setShowModal(true);
            })
            .catch((err) => {
                
            })
    }

    const onSubmitFrom = (data) => {
        AppParamAPI.update(data)
            .then((res) => {
                res.data?.Success ?
                    toast.success(<span className="fs-9 fw-bold">Your application parameter has been updated.</span>)
                    : toast.error(<span className="fs-9 fw-bold">An error occurred while updating your application parameter.</span>)
            })
            .catch((err) => {
                toast.error(<span className="fs-9 fw-bold">An error occurred while updating your application parameter.</span>)
            })
            .finally(() => {
                setShowModal(false);
                setReloadTable(prev => !prev);
            })
    }
    return (
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-4">Application Parameter</h2>
            {loading ? (
                <SkeletonTableLoading columns={tableConfig.columns} rows={10} />
            ) : (
                <Table tableConfig={{...tableConfig, data : appParam}}/>
            )}
            <CenteredModal show={showModal}
                           title="Edit Application Param"
                           onClose={() => setShowModal(false)}
                           formId="formActionAppParam"
            >
                <div className="mb-3">
                    <form onSubmit={handleSubmit(onSubmitFrom)} id="formActionAppParam">
                        <div className="mb-3">
                            <FormInput showHeaderLabel={true}
                                       name = "ParamValue"
                                       errors={errors}
                                       required= {true}
                                       label="Assign Param Value"
                                       validation={{...register("ParamValue", {
                                               required: "Param Value is required."
                                           })}}
                            />
                        </div>
                        <div className="mb-3">
                            <FormInput showHeaderLabel={true}
                                       name = "Description"
                                       errors={errors}
                                       required= {true}
                                       label="Assign Description"
                                       validation={{...register("Description", {
                                               required: "Description is required."
                                           })}}
                            />
                        </div>
                    </form>
                </div>
            </CenteredModal>
        </Fragment>
    )
}
export default ApplicationParameter;